angular.module('study.dashboard')
    .component('queriesStatusReportSummary', {
        templateUrl: 'modules/dashboard/components/queries-status-report-summary/template.html',
        bindings: {
            hideFooter: '<',
        },
        controller: [
            'CrdConfigurationService',
            '$window',
            'ShareCrfSDK',
            'gettextCatalog',
            'queryStatusFilter',
            'ShareCrfApiErrorCodes',
            '$timeout',
            function(
                CrdConfigurationService,
                $window,
                ShareCrfSDK,
                gettextCatalog,
                queryStatusFilter,
                ShareCrfApiErrorCodes,
                $timeout
            ) {
                var vm = this;

                var c3 = $window.c3;

                vm.data = {};
                var charts = {};

                vm.entityLabel = CrdConfigurationService.getLabelPlural();
                vm.loading = true;
                vm.error = false;

                vm.queryRate = null;

                var statusColors = {};
                statusColors[queryStatusFilter('new')] = 'darkred';
                statusColors[queryStatusFilter('updated')] = 'darkorange';
                statusColors[queryStatusFilter('resolution_proposed')] = 'darkgreen';
                statusColors[queryStatusFilter('closed')] = 'black';

                vm.$onInit = function() {
                    createCharts();

                    loadData();
                };

                function loadData() {
                    vm.loading = true;

                    return ShareCrfSDK.dashboard.queriesStatusSummary().then(function(data) {
                        vm.data = data;

                        vm.queryRate = vm.data.records.total > 0 ? vm.data.queries.total / vm.data.records.total : 0;

                        if (vm.data.queries.total > 0) {
                            charts.byStatusSummary.load({
                                columns: [
                                    [gettextCatalog.getString('Abiertas'), vm.data.queries.status.open],
                                    [gettextCatalog.getString('Cerradas'), vm.data.queries.status.closed],
                                ],
                            });

                            charts.byType.load({
                                columns: [
                                    [gettextCatalog.getString('Manuales', {}, 'no automáticas'), vm.data.queries.type.manual],
                                    [gettextCatalog.getString('Automáticas'), vm.data.queries.type.automatic],
                                ],
                            });
                        }

                        if (vm.data.queries.status.open > 0) {
                            charts.byStatusDetail.load({
                                columns: ['new', 'updated', 'resolution_proposed'].map(function(key) {
                                    return [queryStatusFilter(key), vm.data.queries.detailStatus[key] || 0];
                                }),
                            });
                        }
                    }).catch(function(error) {
                        vm.error = ShareCrfApiErrorCodes.getHumanReadableMessage(error);

                        throw error;
                    }).finally(function() {
                        vm.loading = false;
                    });
                }

                function createCharts() {
                    var pieOptions = {
                        data: {
                            type: 'pie',
                            columns: [],
                            empty: {
                                label: {
                                    text: gettextCatalog.getString('No hay datos'),
                                },
                            },
                        },
                        pie: {
                            label: {
                                format: function(value) {
                                    return value;
                                },
                            },
                        },
                        tooltip: {
                            format: {
                                value: function (value) {
                                    return value;
                                },
                            },
                        },
                        size: {
                            height: 200,
                        },
                    };

                    $timeout(function() {
                        charts = {
                            byStatusSummary: c3.generate(angular.merge({
                                bindto: '#queries-by-status-summary',
                                color: {
                                    pattern: ['#455b73', '#e67259'],
                                },
                            }, pieOptions)),
                            byStatusDetail: c3.generate(angular.merge({
                                bindto: '#queries-by-status-detail',
                                data: {
                                    colors: statusColors,
                                },
                            }, pieOptions)),
                            byType: c3.generate(angular.merge({
                                bindto: '#queries-by-type',
                                color: {
                                    pattern: ['#455b73', '#e67259'],
                                },
                            }, pieOptions)),
                        };
                    });
                }
            },
        ],
    });
